<template>
  <div class="brainsSelector-wrapper">
    <div class="brainsSelect-input-wrapper">
      <input
        :id="'brainsSelectorID_' + _uid"
        v-model="holderValue"
        autocomplete="off"
        :placeholder="placeholder !== '' ? placeholder : temporalPlaceholder"
        :disabled="disabled"
        @mouseup="onClickInput()"
        @blur="onBlurInput()"
        @keyup.enter="onEnterInput()"
        @keyup="keyupEvent()"
      >
      <div class="brainsSelect-input-arrow" :class="{'brainsSelect-input-arrow--open':isOpenList}" />
    </div>
    <div class="brainsSelect-list-wrapper" :class="{'brainsSelect-list-wrapper--open':isOpenList}">
      <div class="brainsSelect-list">
        <div
          v-for="(item, index) in filteredList"
          :key="index"
          class="brainsSelect-list-item"
          :class="{'brainsSelect-list-item--selected':(listKey !== '' ? item[listKey] : item) === selectedValue}"
          @mousedown="onSelectItem(item)"
        >
          {{ listLabel !== '' ? item[listLabel] : item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      required: true
    },
    listKey: {
      type: String,
      default: 'id_DEFAULT'
    },
    listLabel: {
      type: String,
      default: 'name_DEFAULT'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedValue: null,
      holderValue: null,
      isOpenList: false,
      temporalPlaceholder: ''
    }
  },
  computed: {
    formattedList: {
      get() {
        if (this.listKey === 'id_DEFAULT') {
          return this.list.map((item) => {
            return {
              id_DEFAULT: item,
              name_DEFAULT: item
            }
          })
        }
        return this.list
      }
    },
    filteredList: {
      get() {
        var vm = this
        if (this.holderValue === '') { return this.formattedList }
        return this.formattedList.filter(item => vm.tryLower(item[vm.listLabel]).includes(vm.tryLower(vm.holderValue)))
      }
    }
  },
  watch: {
    value: function() {
      var vm = this
      this.selectedValue = this.value
      var bExists = this.formattedList.find(f => f[vm.listKey] === vm.value)
      this.holderValue = bExists ? bExists[vm.listLabel] : ''
    }
  },
  mounted() {
    this.selectedValue = this.value
    this.holderValue = this.value
  },
  methods: {
    tryLower(itm) {
      return (typeof itm === 'string' || itm instanceof String) ? itm.toLowerCase() : itm
    },
    onClickInput() {
      if (this.isOpenList) {
        document.getElementById('brainsSelectorID_' + this._uid).blur()
      } else {
        this.onFocusInput()
      }
    },
    onFocusInput() {
      this.isOpenList = true
      this.temporalPlaceholder = this.holderValue
      this.holderValue = ''
    },
    onBlurInput() {
      this.isOpenList = false
      if ((this.holderValue === '' || !this.isInList())) {
        this.holderValue = this.temporalPlaceholder
      }
    },
    onEnterInput() {
      if (this.filteredList.length > 0 && this.holderValue !== '') {
        this.onSelectItem(this.filteredList[0])
      }
      document.getElementById('brainsSelectorID_' + this._uid).blur()
    },
    onSelectItem(item) {
      this.holderValue = this.listLabel !== '' ? item[this.listLabel] : item
      this.selectedValue = this.listKey !== '' ? item[this.listKey] : item
      this.$emit('input', this.selectedValue)
    },
    isInList() {
      var vm = this
      return this.formattedList.some(s => s[vm.listLabel] === vm.holderValue)
    },
    keyupEvent() {
      this.$emit('keyup', this.holderValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.brainsSelector-wrapper {
  height: 32px;
  min-width: 80px;
  font-size: 12px;
  position: relative;
  font-family: 'Montserrat-Regular',sans-serif;

  .brainsSelect-input-wrapper {
    width: 100%;
    height: 100%;
    position: relative;

    input {
      min-width: 130px;
      width: 100%;
      height: 100%;
      padding: 0 10px;
      border: 1px solid lightgrey;
      font-family: 'Montserrat-Regular',sans-serif;
      font-size: 11px;
      outline: none;
      border-radius: 4px;
      color: rgba(0, 0, 0, 0.8);
      cursor: pointer;

      &::placeholder {
        color: rgba(211, 211, 211, 0.836);
      }

      &:focus {
        outline: 1px solid #1e3cff;
      }
    }

    .brainsSelect-input-arrow {
      position: absolute;
      top: 12px;
      right: 7px;
      height: 10px;
      width: 10px;
      cursor: pointer;
      pointer-events: none;

      &::before, &::after {
        content: "";
        position: absolute;
        bottom: 0px;
        width: 0.10rem;
        height: 100%;
        transition: all 0.3s;
      }
      &::before {
        left: -3px;
        transform: rotate(-45deg);
        background-color: lightgrey;
      }
      &::after {
        left: 3px;
        transform: rotate(45deg);
        background-color: lightgrey;
      }

      &--open::before {
        left: 3px;
        transform: rotate(-45deg);
      }
      &--open::after {
        left: -3px;
        transform: rotate(45deg);
      }
    }
  }

  .brainsSelect-list-wrapper {
    top: 32px;
    left: 0;
    width: 100%;
    position: absolute;
    display: none;
    background-color: white;
    z-index: 99;
    border: 1px solid lightgrey;
    border-radius: 3px;
    overflow: hidden;
    animation: growDown 300ms ease-in-out forwards;
    transform-origin: top center;

    &--open {
      display: block;
    }

    .brainsSelect-list-item {
      display: flex;
      width: 100%;
      align-items: center;
      padding: 10px 15px;
      cursor: pointer;

      &--text {
        width: 100%;
        word-wrap: break-word;
        white-space: initial;
      }

      &--selected {
        font-family: 'Montserrat-SemiBold',sans-serif;
        color: #1e3cff;
      }

      &:hover {
        background-color: rgba(211, 211, 211, 0.6);
      }
    }
  }

  .brainsSelect-list {
    width: 100%;
    max-height: 250px;
    overflow-y: overlay;
    overflow-x: hidden;
    margin-right: -7px;

    &::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #1e3cff;
      border-radius: 5px;
    }
  }
}

@keyframes growDown {
    0% {
        transform: scaleY(0)
    }
    // 80% {
    //     transform: scaleY(1.1)
    // }
    100% {
        transform: scaleY(1)
    }
}
</style>
